/*
 * Public API Surface of angular-sidebar-menu
 */

export * from './lib/sidebar-menu.component';
export * from './lib/sidebar-menu.module';
export * from './lib/sidebar-menu.interface';
